<template>
  <div class="news-page">

    <!-- 搜索弹窗 -->
    <div class="search" v-show="searchVisible">
      <div class="sc_bj">
        <div class="sc_gb" @click="toggleSearch"><i class="iconfont icon-guanbi1"></i></div>
        <div class="sc_nr">
          <input type="text" v-model="searchKeyword" placeholder="Please enter keywords">
          <button @click="handleSearch"><i class="iconfont icon-tubiaozhizuomoban"></i></button>
          <div class="clear"></div>
        </div>
      </div>
    </div>

    <!-- 新闻列表主体 -->
    <div class="ny_xw">
      <div class="container">
        <!-- 位置导航 -->
        <div class="dq_lm"><i class="iconfont icon-dizhi1"></i> <a href="/">Home</a> - <a href="/news">News</a></div>

        <!-- 列表标题和筛选 -->
        <div class="lm_bt">
          <div class="b_t">NEWS</div>
          <div class="s_x">
            <div class="x_z">
              <span>Category</span>
              <el-cascader style="width: 150px;margin-left: 15px;" :options="typeList" :show-all-levels="false"
                placeholder="Please select a type..." :props="{ value: 'id', label: 'value', children: 'data' }" clearable
                @change="handleNewsTypeChange"></el-cascader>
            </div>
            <div class="x_z">
              <span>Year</span>
              <el-select v-model="nowYear" placeholder="Please select a year..." style="width: 150px;margin-left: 15px;" @change="listNews2Fuc">
                <el-option v-for="year in yearList" :key="year.value" :label="year.label" :value="year.value" />
              </el-select>
            </div>
          </div>
        </div>

        <!-- 新闻列表 -->
        <div class="xw_lb">
          <ul v-if="filteredNewsList.length">
            <li v-for="(news, index) in newsList" :key="index">
              <div class="s_j">{{ initTime(news.ctime) }}</div>
              <div class="n_r">
                <div class="w_z">
                  <h3><a :href="`/news_detail/${news.id}`">{{ news.title }}</a></h3>
                  <p>{{ news.detail }}</p>
                </div>
                <div class="t_p"><a :href="`/news_detail/${news.id}`"><img
                      :src="`https://cdn.bosscaigou.com/${news.himg}`"></a></div>
              </div>
            </li>
          </ul>
          <!-- 空状态 -->
          <div class="empty-state" v-else>
            <p>No news found matching your criteria.</p>
          </div>
        </div>
        <el-pagination class="com-aonaer-wm-pagination" size="" background @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="nowPge" :page-sizes="[12, 24, 36, 48]"
          :page-size="nowPsz" layout="prev, pager, next" :total="maxSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// 引入WOW动画（如需保留动画效果）
import WOW from 'wowjs'
import { listNews2 } from '@/api'
import { initTime } from '@/utils/myutils'
export default {
  name: 'News',
  data() {
    return {
      // 年份列表
      yearList: [],
      // 新闻类型列表
      typeList: [],
      // 筛选参数
      nowType: -1,
      nowYear: -1,
      nowPge: 1,
      nowPsz: 12,
      maxSize: 0,
      // 搜索相关
      searchVisible: false,
      searchKeyword: '',
      // 语言下拉框
      languageDropdownVisible: false,
      // 移动端导航
      mobileNavVisible: false,
      // 筛选参数
      filterParams: {
        category: 'All',
        year: 'ALL'
      },
      // 分页参数
      currentPage: 1,
      pageSize: 6, // 每页显示条数
      totalPages: 6, // 总页数（模拟数据）
      // 新闻原始数据
      newsList: []
    }
  },
  computed: {
    // 筛选后的新闻列表
    filteredNewsList() {
      let result = [...this.newsList]

      // 按分类筛选
      if (this.filterParams.category !== 'All') {
        result = result.filter(news => news.category === this.filterParams.category)
      }

      // 按年份筛选
      if (this.filterParams.year !== 'ALL') {
        result = result.filter(news => news.year === this.filterParams.year)
      }

      // 更新总页数
      this.totalPages = Math.ceil(result.length / this.pageSize)
      // 重置当前页（筛选后回到第一页）
      if (this.currentPage > this.totalPages && this.totalPages > 0) {
        this.currentPage = this.totalPages
      }

      return result
    },
    // 分页后的新闻列表
    paginatedNewsList() {
      const startIndex = (this.currentPage - 1) * this.pageSize
      const endIndex = startIndex + this.pageSize
      return this.filteredNewsList.slice(startIndex, endIndex)
    },
    // 分页显示逻辑 - 可见页码
    visiblePages() {
      // 显示当前页前后各1页
      const pages = []
      const half = 1

      // 计算显示范围
      let start = Math.max(2, this.currentPage - half)
      let end = Math.min(this.totalPages - 1, this.currentPage + half)

      // 边界处理
      if (this.totalPages <= 5) {
        start = 2
        end = this.totalPages - 1
      }

      for (let i = start; i <= end; i++) {
        pages.push(i)
      }

      return pages
    },
    // 是否显示第一页
    showFirstPage() {
      return this.currentPage > 2 || this.totalPages <= 5
    },
    // 是否显示最后一页
    showLastPage() {
      return this.currentPage < this.totalPages - 1 || this.totalPages <= 5
    },
    // 是否显示前面的省略号
    showFirstEllipsis() {
      return this.currentPage > 3 && this.totalPages > 5
    },
    // 是否显示后面的省略号
    showLastEllipsis() {
      return this.currentPage < this.totalPages - 2 && this.totalPages > 5
    }
  },
  mounted() {

    window.scrollTo(0, 0)
    // 初始化WOW动画（如需保留）
    if (typeof WOW !== 'undefined') {
      new WOW.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      }).init()
    }

    // 初始化新闻列表
    this.listNews2Fuc();

    this.yearList = this.generateYearOptions();

    // 滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {

    handleNewsTypeChange(item) {
      this.nowType = item.length == 0 ? -1 : item[item.length - 1];
      this.listNews2Fuc();
    },
    initTime(time) {
      return initTime(time, 'YYYY-MM-DD');
    },
    generateYearOptions() {
      // 1. 获取当前年份（四位数字，如2026）
      const currentYear = new Date().getFullYear();

      // 2. 初始化结果数组，先加入ALL选项
      const yearOptions = [{ label: 'ALL', value: -1 }];

      // 3. 循环生成从当前年份到2025年的年份选项
      // 注意：如果当前年份 < 2025（比如2024），则只生成到当前年份（避免生成2025、2024之外的无效年份）
      const startYear = currentYear;
      const endYear = 2025;
      const step = startYear > endYear ? -1 : 1; // 确定循环方向：当前年>2025则递减，否则递增

      for (let year = startYear;
        step > 0 ? year <= endYear : year >= endYear;
        year += step) {
        yearOptions.push({
          label: year.toString(), // 也可以直接用数字，根据你的需求调整
          value: year
        });
      }

      return yearOptions;
    },
    async listNews2Fuc() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const data = await listNews2({
        key: '',
        pge: this.nowPge,
        psz: this.nowPsz,
        year: this.nowYear,
        type: this.nowType
      })
      loading.close();
      if (data?.code === 200) {
        this.newsList = data?.data || [];
        this.typeList = data?.type || [];
        this.maxSize = data?.count || 0;
      } else {
        this.$message.error(data?.message || '获取新闻列表失败');
      }
    },
    // ========== 筛选功能 ==========
    handleFilter() {
      // 筛选后重置到第一页
      this.currentPage = 1
    },

    // ========== 分页功能 ==========
    changePage(page) {
      // 边界检查
      if (page < 1 || page > this.totalPages) return

      this.currentPage = page

      // 滚动到列表顶部
      const newsListEl = document.querySelector('.xw_lb')
      if (newsListEl) {
        newsListEl.scrollIntoView({ behavior: 'smooth' })
      }
    },

    // ========== 搜索功能 ==========
    toggleSearch() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.$nextTick(() => {
          const searchInput = document.querySelector('.sc_nr input')
          searchInput?.focus()
        })
      }
    },

    handleSearch() {
      if (!this.searchKeyword.trim()) {
        alert('Please enter search keywords')
        return
      }

      // 简单的标题/摘要搜索
      const keyword = this.searchKeyword.toLowerCase()
      this.filteredNewsList = this.newsList.filter(news =>
        news.title.toLowerCase().includes(keyword) ||
        news.summary.toLowerCase().includes(keyword)
      )

      this.searchVisible = false
      this.currentPage = 1
    },

    // ========== 语言下拉框 ==========
    toggleLanguage() {
      this.languageDropdownVisible = !this.languageDropdownVisible
    },

    // ========== 移动端导航 ==========
    toggleMobileNav() {
      this.mobileNavVisible = !this.mobileNavVisible
      document.body.style.overflow = this.mobileNavVisible ? 'hidden' : ''
    },

    // ========== 滚动相关 ==========
    handleScroll() {
      // 可添加滚动时的样式变化逻辑
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped></style>